export enum MessageType {
  ADD_RECORDING_PROGRESS,
  ADD_LAYER,
  REMOVE_LAYER,
  GET_LEVELS,
  START_RECORDING,
  STOP_RECORDING,
  GET_RECORD_DATA,
  GET_COMPILED_RECORD,
  SET_LAYER_VOLUME,
  GET_RECORD_LENGTH,
  UNDO,
  REDO,
  ON_LAYER_CHANGE,
  ON_RECORD_CHANGE,
  ON_HISTORY_CHANGE,
}



// WEBPACK FOOTER //
// ./worker/src/message-type.ts